import FaceAPI from './API/FaceAPI';
/**
 * FaceService constructor.
 * @param {FaceAPI} faceApi
 */
export default class FaceService {
    constructor(faceApi) {
        this.faceApi = faceApi;
        this.removeTemporalMethod = null;
    }

    async searchDuplicates(externalId, imgData, collectionIds) {
        return await this.faceApi.searchDuplicates(externalId, imgData, collectionIds);
    }

    async addTemporal(collectionId, externalId, imgData) {
        this.subscribeRemoveTemporal(collectionId, externalId);
        return await this.faceApi.addTemporal(collectionId, externalId, imgData);
    }

    async removeTemporal(collectionId, externalId) {
        return await this.faceApi.removeTemporal(collectionId, externalId);
    }

    async promoteToPermanent(collectionId, externalId) {
        this.unsubscribeRemoveTemporal();
        return await this.faceApi.promoteToPermanent(collectionId, externalId);
    }

    subscribeRemoveTemporal(collectionId, externalId) {
        const selfCollectionId = collectionId;
        const selfExternalId = externalId;
        this.removeTemporalMethod = this.removeTemporal.bind(this, selfCollectionId, selfExternalId);
        window.addEventListener('beforeunload', this.removeTemporalMethod);
    }

    unsubscribeRemoveTemporal() {
        if (this.removeTemporalMethod) {
            window.removeEventListener('beforeunload', this.removeTemporalMethod);
        } else {
            console.log('There is no removeTemporalMethod!');
        }
    }
}
